import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import fields from "../../json/HallRoomTypeFields.json";
import {
    Delete,
    GetAll
} from "adminApi/HallRoomTypeApi/HallRoomType";
import { FilterStatus } from "utils/FilterStatus";
import { FilterDropdown } from "utils/FilterDropdown";


const HallRoomTypeListTable = () => {
    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const debouncedSearch = useDebouncedValue(search, 500);
    const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
    const sizeOptions = [10, 20, 50, 100];

    const { tabledata } = fields

    // Fetch Hook
    const { data, meta, loading, error, refetch } = usePaginatedFetch(GetAll, {
        page,
        limit,
        search: debouncedSearch,
        title: "Hall Room Type List",
    });

    const displayFields = generateDisplayFields(tabledata);

    const filterstutas = FilterStatus(data);

    const filterdata = FilterDropdown(filterstutas);

    // Table Hook
    const { formattedData, columns } = useTableConfig({
        data: filterdata,
        page,
        limit,
        canShowAction,
        refetch,
        config: {
            entityName: "Hall Room Type",
            editUrl: "edit-hall-room-type",
            idKey: "id",
            deleteApi: Delete,
            displayFields,
        },
    });

    const handleSearch = (val, resetPage = null) => {
        setSearch(val);
        if (resetPage !== null) setPage(resetPage);
    };

    const onPageChange = (p) => setPage(p);
    const onLimitChange = (newLimit) => {
        setLimit(newLimit);
        setPage(1);
    };

    return (
        <DataTable
            columns={columns}
            data={formattedData}
            options={{
                loading,
                error,
                sortableColumns: displayFields.map((f) => f.accessor),
                copy: true,
                csv: true,
                pdf: true,
                print: true,
                fileName: "hall/room types list",
            }}
            Search={{
                search: true,
                SearchInputValue: search,
                handleSearch: handleSearch,
            }}
            Entries={{
                Entries: true,
                limit,
                onLimitChange,
                options: sizeOptions,
            }}
            pagination={{
                isActive: true,
                meta,
                onPageChange,
            }}
        />
    );
};

export default HallRoomTypeListTable;
